import React from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { Button, Table, Spinner } from 'react-bootstrap';
import { SearchAlt } from '@styled-icons/boxicons-regular/SearchAlt';
import { CommentEdit } from '@styled-icons/boxicons-regular/CommentEdit';

//Actions
import { pesquisa, novoatualiza } from '../../../../actions/produto/prodprecos';

//Components
import { campotexto, campomoney, Campocalendario } from '../../../../components/forms/campos/campos';

//Utils
import { getEvento } from '../../../../utils/eventosession';

class FormProdutosPrecosLista extends React.Component {

    state = {
        itemselecinado: {}
    }

    componentDidMount(){
        const evento = getEvento();
        this.props.pesquisa({idpromotora: evento.idpromotora, idsubitems: this.props.subitem.idsubitems});
    }

    handleSubmit = async (form) => {
        const evento = getEvento();             
        const dados = {
            idpromotora: evento.idpromotora,
            idsubitems: this.props.cadastros[0].idsubitems,
            ...form            
        }
        await this.props.novoatualiza(dados);
        await this.props.pesquisa({idpromotora: evento.idpromotora, idsubitems: this.props.subitem.idsubitems});
        setTimeout(() => (
            this.formfinal.reset()
        ),500)
    }

    handleEditar = (item) => {
        this.setState({
            itemselecinado: {
                idtabelaprecossubitems: item.idtabelaprecossubitems,
                valor: item.valor,
                datalimite: item.datalimite,
                datainicio: item.datainicio
            }
        })        
    }

    handleNovo = (form) => {
        this.setState({
            itemselecinado: {}
        });
        form.reset();
    }
        
    render() {      
        console.log(this.state.itemselecinado);
        return (
            <Form
            onSubmit={this.handleSubmit}            
            validate={values => {
                const errors = {};
                if(!values.valor){
                    errors.valor = 'Obrigatório'
                }                
                return errors;
            }}
            mutators={{                    
                ...arrayMutators,
                setValue: ([field, value], state, { changeValue }) => {
                    changeValue(state, field, () => value)
                }                    
            }}
            initialValues={this.state.itemselecinado}
            render={({ submitting, pristine, form, handleSubmit }) => {
                this.formfinal = form;
                return (
                    <form onSubmit={handleSubmit}>
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th colSpan="2">Pesquisa Produtos</th>                                
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <Field type="text" name="portugues" component={campotexto} placeholder={this.props.placeholder} />
                                    </td>                                
                                    <td className="text-center">
                                        <Button type="submit">                                            
                                            {this.props.pendingTasks?
                                            <Spinner animation="border"  />
                                            :
                                            <SearchAlt size="30" disabled={pristine || submitting} />
                                            }
                                        </Button>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>                    
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                <th>Nacional</th>
                                <th>Data Inicio</th>
                                <th>Data Final</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.cadastros.length?this.props.cadastros.map(itens => {
                                    return (
                                        <tr key={itens.idtabelaprecossubitems}>
                                            <td>
                                                {itens.valor}
                                                <CommentEdit style={{cursor: "pointer"}} onClick={() => this.handleEditar(itens)} size="35" />
                                            </td>
                                            <td>
                                                {itens.datalimite}
                                            </td>
                                            <td>
                                                {itens.datainicio}
                                            </td>                                            
                                        </tr>  
                                    )
                                })
                                :
                                null
                                }    
                                <tr>
                                    <td colSpan="4">                                    
                                        <Field type="hidden" name="idtabelaprecossubitems" component={campotexto} />
                                        <Field type="text" name="valor"                                        
                                        component={campomoney} form={form} />
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="4">
                                        <Field type="text" label="Data Inicio" form={form} name="datainicio" component={Campocalendario} />
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="4">
                                        <Field type="text" label="Data Final" form={form} name="datalimite" component={Campocalendario} />
                                    </td>                                    
                                </tr>
                                <tr>
                                    <td colSpan="4" className="text-center">
                                        <Button type="submit" disabled={pristine || submitting}>Confirmar</Button>
                                    </td>
                                </tr>
                                <tr>                                
                                    <th colSpan="4" className="text-center">
                                        <Button type="button" onClick={() => this.handleNovo(form)}>Novo</Button>
                                    </th>
                                </tr>             
                            </tbody>
                        </Table>
                    </form>
                )
            }}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {        
        pendingTasks: state.pendingTasks,
        cadastros: state.reducerPesquisaProdPreco,
        subitem: state.reducerSubitemSelecionado
    }
}

export default connect(mapStateToProps, { pesquisa, novoatualiza })(FormProdutosPrecosLista);